import { getSceneDurationInSeconds } from "./getSceneDurationInSeconds.js";
import { getStartFrameOfNextItem, toFrames } from "./frames-lib.js";
/**
 * The returned duration is in frames.
 */
export function getSceneDurationAtFrame(frame, renderConfig, theme) {
    let currentSceneStartFrame = 0;
    for (const scene of theme.scenes) {
        const currentSceneDurationInFrames = toFrames(getSceneDurationInSeconds(scene, renderConfig, theme), renderConfig.videoFrame.fps);
        if (currentSceneDurationInFrames === 0) {
            // don't need to update currentSceneStartFrame because this scene doesn't
            // take up any frames and the next scene will start at
            // currentSceneStartFrame
            continue;
        }
        // this might be beyond the last scene, but it doesn't matter because we're
        // just using it to figure out if `frame` is in the current scene
        const nextSceneStartFrame = getStartFrameOfNextItem({
            currentItemStartFrame: currentSceneStartFrame,
            currentItemDuration: currentSceneDurationInFrames,
        });
        // if this condition is true, then `frame` comes before the start of the
        // next scene (and is therefore in this scene)
        if (frame < nextSceneStartFrame) {
            return currentSceneDurationInFrames;
        }
        // set the start frame for the next iteration
        currentSceneStartFrame = nextSceneStartFrame;
    }
    throw Error(`Frame ${frame} is beyond the last scene in the theme.`);
}
